<div class="row-wrapper client-case-id-component">
    <div class="input-box component-container">
        <div class="input-row first">
            <div class="input">
                <h3>Schadennummer</h3>
                <div class="id-components-container">
                    <ng-container *ngFor="let component of model.idComponentsConfiguration; index as i">
                        <app-custom-select *ngIf="component.type=='DROP_DOWN'"
                                           [options]="component[component.activeList]"
                                           [result]="clientCaseId.main[i]" [maxlength]="component.maxLength"
                                           (resultChange)="onResultChange($event, 'main', i)"
                                           id="main.{{i}}"
                                           styleClass="nomargin dropdown-{{i}} caseidpartial-{{i}} dropdown-maxlength-{{component.maxLength}}">
                        </app-custom-select>
                        <app-custom-input *ngIf="component.type=='TEXT'"
                                          [maxlength]="component.maxLength"
                                          [result]="clientCaseId.main[i]"
                                          [restrict]="component.restrict"
                                          (resultChange)="onResultChange($event, 'main', i)"
                                          [errors]="errors"
                                          [upperCase]="true"
                                          inputId="main.{{i}}"
                                          modelPath="main.{{i}}"
                                          id="main.{{i}}"
                                          styleClass="caseidpartial-{{i}} input-maxlength-{{component.maxLength}}">
                        </app-custom-input>
                        <app-custom-radio-group *ngIf="component.type=='RADIO'"
                                                [options]="component.options"
                                                [result]="clientCaseId.main[i]"
                                                (resultChange)="onResultChange($event, 'main', i)" name="main.{{i}}"
                                                id="main.{{i}}">
                        </app-custom-radio-group>
                    </ng-container>
                    <ng-container *ngIf="partialCaseActivated && partialCaseEnabled">
                        <!--<app-custom-checkbox [(result)]="isPartialCase" label="Teilakte" labelPosition="after"></app-custom-checkbox>-->
                        <mat-checkbox color="primary" [(ngModel)]="isPartialCase" labelPosition="after">Teilakte
                        </mat-checkbox>
                        <!--<app-custom-tooltip *ngIf="showTooltip" type="INFO" position="after"
                         [tooltips]="tooltips" key="PARTIAL_CASE_ID_TIP" class="tooltip"></app-custom-tooltip>-->
                        <span class="info-container">
                            <button mat-icon-button class="info" *ngIf="showTooltip">
                                <i class="icon ic-icon_info"></i>
                                <div class="tooltiptext" [innerHTML]="tooltipText"></div>
                            </button>
                        </span>
                        <span class="id-component-partial"
                              *ngFor="let component of model.idPartialsConfiguration; index as i"
                              [ngClass]="{'select-component': component.type=='DROP_DOWN', 'text-component': component.type=='TEXT'}">
                            <ng-container *ngIf="isPartialCase">
								<app-custom-select *ngIf="component.type=='DROP_DOWN'"
                                                   [options]="component.options"
                                                   [result]="clientCaseId.partial[i]"
                                                   class="nomargin"
                                                   (resultChange)="onResultChange($event, 'partial', i)"
                                                   id="partial.{{i}}"
                                                   [id]="component.id">
								</app-custom-select>
								<app-custom-input *ngIf="component.type=='TEXT'"
                                                  [result]="clientCaseId.partial[i]" [maxlength]="component.maxLength"
                                                  [restrict]="component.restrict"
                                                  (resultChange)="onResultChange($event, 'partial', i)"
                                                  [upperCase]="true"
                                                  inputId="partial.{{i}}"
                                                  id="partial.{{i}}">
                                </app-custom-input>
								<app-custom-radio-group *ngIf="component.type=='RADIO'"
                                                        [options]="component.options"
                                                        [result]="clientCaseId.partial[i]"
                                                        (resultChange)="onResultChange($event, 'partial', i)"
                                                        name="partial.{{i}}"
                                                        id="partial.{{i}}">
								</app-custom-radio-group>
                                <span *ngIf="component.type=='TEXT_OUT'">
                                   -{{clientCaseId.partial[i]}}
                                </span>
                            </ng-container>
                        </span>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
